<template>
  <div class="path-card" @click="$emit('click')">
    <!-- Indicatore di completamento -->
    <div v-if="completed" class="completion-badge">
      <span class="completion-text">COMPLETED</span>
    </div>
    
    <!-- Indicatore coming soon -->
    <div v-if="comingSoon" class="coming-soon-badge">
      <span class="coming-soon-text">COMING SOON</span>
    </div>
    
    <div class="path-content">
      <div class="path-header">
        <h3 class="path-title">{{ title }}</h3>
        <div class="path-missions">{{ missionsCount }} missions</div>
        <div v-if="locked" class="path-locked">
          <TabIcon name="lock" :size="24" />
        </div>
      </div>
      <div class="path-duration">{{ duration }}</div>
    </div>
    <div class="path-image" :style="{ backgroundColor: cardColor }">
      <img :src="imageUrl" :alt="title" loading="lazy" />
    </div>
  </div>
</template>

<script setup lang="ts">
import TabIcon from './TabIcon.vue';

defineProps<{
  title: string;
  missionsCount: number;
  duration: string;
  imageUrl: string;
  locked?: boolean;
  cardColor?: string;
  completed?: boolean;
  comingSoon?: boolean;
}>();

defineEmits(['click']);
</script>

<style scoped>
.path-card {
  display: flex;
  width: 100%;
  background-color: #FAF6F4;
  border-radius: 8px;
  overflow: visible;
  box-shadow: 0px 2px 0px 0px rgba(209, 209, 209, 1);
  margin-bottom: 8px;
  cursor: pointer;
  flex-direction: row;
  position: relative;
}

.path-image {
  width: 150px;
  height: 140px;
  background-color: #F8AE62;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-top: 10px;
  padding: 10px 10px 0 10px;
  position: relative;
}

.path-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.path-content {
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.path-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.path-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.2222222222222223em;
  color: #2D2D2D;
  margin: 0;
}

.path-missions {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5em;
  color: #737373;
}

.path-locked {
  display: flex;
  align-items: center;
  color: #737373;
}

.path-duration {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5em;
  color: #737373;
  margin-top: auto;
}

.completion-badge {
  position: absolute;
  top: 20px;
  right: 12px;
  background-color: #4CAF50;
  border-radius: 8px;
  padding: 3px 10px 6px;
  z-index: 10;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}

.completion-text {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 11px;
  line-height: 1.2;
  color: #FFFFFF;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.coming-soon-badge {
  position: absolute;
  top: 20px;
  right: 12px;
  background-color: #FFA500;
  border-radius: 8px;
  padding: 3px 10px 6px;
  z-index: 10;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}

.coming-soon-text {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 11px;
  line-height: 1.2;
  color: #FFFFFF;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style> 